module.exports = __webpack_public_path__ + "img/01_noff_open_L1.36fd470a.svg";